import { styled } from '@mui/material'

export const FlexGrow = styled('div')({
  flexGrow: 1,
})
